export var ImagePanoramicEnum;
(function (ImagePanoramicEnum) {
    ImagePanoramicEnum["front"] = "front";
    ImagePanoramicEnum["rear"] = "rear";
    ImagePanoramicEnum["frontLeft"] = "frontLeft";
    ImagePanoramicEnum["rearLeft"] = "rearLeft";
    ImagePanoramicEnum["frontRight"] = "frontRight";
    ImagePanoramicEnum["rearRight"] = "rearRight";
    ImagePanoramicEnum["left"] = "left";
    ImagePanoramicEnum["right"] = "right";
})(ImagePanoramicEnum || (ImagePanoramicEnum = {}));
